/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';
import ROUTES from '@constants/routes';

import CountrySelect from '../CountrySelect';

const CountryField = React.forwardRef(
  (
    {
      initialCountry,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      queryVariables,
      value,
      ...props
    },
    ref,
  ) => {
    const [selectedCountry, setSelectedCountry] = React.useState(initialCountry);

    const handleChange = (country) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(country);
      setSelectedCountry(country);
    };

    return (
      <>
        <Form.WithFieldValue name={props.name}>
          {(_value) => {
            if (!_value) {
              setSelectedCountry(undefined);
            }
          }}
        </Form.WithFieldValue>
        <Form.ItemWithExtra
          wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
          extra={
            !!selectedCountry && (
              <Link to={`/${ROUTES.MINISITES}/${selectedCountry.id}`} target="_blank" rel="noopener noreferrer">
                Country setup
              </Link>
            )
          }
          {...props}
        >
          <CountrySelect
            value={value}
            ref={ref}
            onChange={handleChange}
            disabled={disabled}
            onSearch={onSearch}
            showAction={showAction}
            placeholder={placeholder}
            queryVariables={queryVariables}
          />
        </Form.ItemWithExtra>
      </>
    );
  },
);

export default CountryField;
